module.exports = __webpack_public_path__ + "04828bff6a666ae679bab5f39a69f572.png";